import React, { Component, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import GridContainer from "../../../../../components/Grid/GridContainer.js";
import GridItem from "../../../../../components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField";
import {
  updateWeight,
  updateProductList,
  updateSearchText,
  getProductPricePreview,
} from "../../../../store/actions";

import Tooltip from "@material-ui/core/Tooltip";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";

import { isEmpty } from "lodash";
import { formatNumber, formatNumberWithDecimals, formatCurrency } from '../../../../utils/formatNumber.js';
import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  defaultFont, whiteColor,
} from "assets/jss/material-kit-pro-react.js";

const useStyles = (theme) => ({
  root: {
    width: "100%",
    padding: "5px",
  },
  paper: {
    width: "100%",
    marginBottom: "10px",
  },
  table: {
    marginBottom: "0",
    padding: "10px",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    overflow: "auto",
    "& > tbody > tr, & > thead > tr": {
      height: "auto",
      border: "1px solid",
    },
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.5em",
    padding: "5px",
    verticalAlign: "middle",
    fontSize: "0.999rem",
    borderBottom: "none",
    borderTop: "2px solid " + grayColor[6],
    position: "relative",
    color: grayColor[1],
    borderWidth: 1,
    borderColor: grayColor[6],
    borderStyle: "solid",
    //Changes
    textAlign: "center",
    width: "auto",
  },
  productTableCell: {
    ...defaultFont,
    lineHeight: "1.5em",
    padding: "5px",
    verticalAlign: "middle",
    fontSize: "0.999rem",
    borderBottom: "none",
    borderTop: "2px solid " + grayColor[6],
    position: "relative",
    color: grayColor[1],
    borderWidth: 1,
    borderColor: grayColor[6],
    borderStyle: "solid",
    //Changes
    textAlign: "left",
    width: "30%",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  tableTileArea: {
    paddingBottom: "10px",
    paddingTop: "20px",
    padding: 4,
    fontSize: "1.299rem",
    fontweight: "bold",
  },
});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "frequency",
    numeric: false,
    disablePadding: true,
    label: "Quantity Purchased to Date",
    canSort: true,
    width: "12%",
  },
  // {
  //   id: "productCode",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Product Code",
  //   canSort: true,
  //   width: "25%",
  // },
  {
    id: "productName",
    numeric: false,
    disablePadding: false,
    label: "Product Name",
    canSort: true,
    width: "20%",
  },
  {
    id: "units",
    numeric: true,
    disablePadding: false,
    label: "Units",
    canSort: true,
    width: "7%",
  },
  {
    id: "packs",
    numeric: true,
    disablePadding: false,
    label: "Packs",
    canSort: true,
    width: "7%",
  },
  {
    id: "totalWeight",
    numeric: true,
    disablePadding: false,
    label: "Total Weight(Tonnes)",
    canSort: true,
    width: "10%",
  },
  {
    id: "packSize",
    numeric: true,
    disablePadding: false,
    label: "Pack Size",
    canSort: true,
    width: "7%",
  },
  {
    id: "weight",
    numeric: true,
    disablePadding: false,
    label: "Weight(Tonnes)",
    canSort: true,
    width: "10%",
  },
  {
    id: "quantity",
    numeric: true,
    disablePadding: false,
    label: "Quantity",
    canSort: true,
    width: "7%",
  },
  {
    id: "unitRate",
    numeric: true,
    disablePadding: false,
    label: "Unit Rate",
    canSort: true,
    width: "10%",
  },
  {
    id: "lineTotal",
    numeric: true,
    disablePadding: false,
    label: "Line Total",
    canSort: true,
    width: "10%",
  },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) =>
          headCell.canSort ? (
            <TableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{ width: headCell.width || "auto", padding: "5px", textAlign: "center", backgroundColor: infoColor[1], color: whiteColor }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc" ? "" : ""}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ) : (
            <TableCell
              key={headCell.id}
              style={{ width: headCell.width || "auto", padding: "5px", textAlign: "center", backgroundColor: infoColor[1], color: whiteColor }}
            >
              {headCell.label}
            </TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
}

let filtervalue = "productCode";
let orderAsc = false;

class OrderProductsTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    filterUsed: "",
    pendingPriceProductIds: new Set(),
  };

  scrollPositionToRestore = undefined;
  pricePreviewTimer = undefined;

  componentDidMount() {
    this.schedulePricePreview();
  }

  componentWillUnmount() {
    if (this.pricePreviewTimer) {
      clearTimeout(this.pricePreviewTimer);
    }

    // avoid state updates after unmount if a preview fetch resolves late.
    this.setState = (state, callback) => {
      return;
    };
  }

  schedulePricePreview = () => {
    if (this.pricePreviewTimer) {
      clearTimeout(this.pricePreviewTimer);
    }
    this.pricePreviewTimer = setTimeout(() => {
      this.fetchPricePreview();
    }, 500);
  };

  fetchPricePreview = () => {
    const { user, selectedDeliverySiteId, selectedBranchId, selectedQuoteId, totalWeight, productList } = this.props;

    if (!user || !selectedDeliverySiteId) {
      return;
    }

    // totalWeight is a string after editing (toFixed) - coerce back to a number for the backend, without mutating redux state.
    const productsWithQuantity = (productList || [])
      .filter((row) => row.quantity > 0)
      .map((row) => ({ ...row, totalWeight: parseFloat(row.totalWeight) }));

    // Only mark rows that have never been priced yet (e.g. the initial mount / basket-restore fetch)
    // as pending here - a row you just edited was already marked pending by markProductPricePending,
    // and rows you didn't touch that already have a price should keep showing it, not flip to a spinner.
    const pricePreview = this.props.pricePreview || {};
    this.setState((prevState) => {
      const pending = new Set(prevState.pendingPriceProductIds);
      productsWithQuantity.forEach((row) => {
        if (!pricePreview[row.productId]) {
          pending.add(row.productId);
        }
      });
      return { pendingPriceProductIds: pending };
    });

    Promise.resolve(
      this.props.getProductPricePreview(
        user.customerId,
        selectedBranchId,
        selectedDeliverySiteId,
        selectedQuoteId,
        totalWeight,
        false,
        0,
        productsWithQuantity
      )
    ).finally(() => {
      this.setState({ pendingPriceProductIds: new Set() });
    });
  };

  markProductPricePending = (productId) => {
    this.setState((prevState) => {
      const pending = new Set(prevState.pendingPriceProductIds);
      pending.add(productId);
      return { pendingPriceProductIds: pending };
    });
  };

  normalizeQuantityInput = (value) => {
    if (value === "") {
      value = "0";
    }

    let valueInt = parseInt(value);
    if (isNaN(valueInt)) {
      valueInt = 0;
    }

    if (valueInt < 0) {
      valueInt = 0;
    }
    return valueInt;
  };

  updateProductQuantities = (packs, units, productId) => {
    // Save scroll position before update
    const scrollContainer = document.getElementById("productTableScrollContainer");
    if (scrollContainer) {
      this.scrollPositionToRestore = scrollContainer.scrollTop;
    }

    this.props.updateProductList(
      packs,
      productId,
      this.props.productList,
      filtervalue,
      orderAsc,
      units
    );

    const inputElement = document.getElementById("searchInput");
    const searchValue = inputElement.value;
    this.props.updateSearchText(searchValue);

    this.markProductPricePending(productId);
    this.schedulePricePreview();
  };

  handlePackChange = (value, productId, currentUnits = 0) => {
    const packs = this.normalizeQuantityInput(value);
    const units = this.normalizeQuantityInput(currentUnits);
    this.updateProductQuantities(packs, units, productId);
  };

  handleUnitChange = (value, productId, currentPacks = 0) => {
    const units = this.normalizeQuantityInput(value);
    const packs = this.normalizeQuantityInput(currentPacks);
    this.updateProductQuantities(packs, units, productId);
  };

  //updateFilterState = (value) => {
  //    this.setState({ filterUsed: "d" }, () => {
  //        console.log(value, 'outside')
  //    });

  //}

  render() {
    const useSortableData = (items, config = null, startText) => {
      const [sortConfig, setSortConfig] = React.useState(config);
      const [productList, setProductList] = React.useState(items);
      const [searchingText, setSearchingText] = React.useState(startText);
      const [displaySearchText, setDisplaySearchText] = React.useState(startText);
      const [selectedGroupId, setSelectedGroupId] = React.useState("0");
      const searchDebounceRef = React.useRef(null);

      const sortedItems = React.useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
          sortableItems.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
              return sortConfig.direction === "ascending" ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
              return sortConfig.direction === "ascending" ? 1 : -1;
            }
            return 0;
          });
        }
        setProductList(sortableItems);
        return sortableItems;
      }, [items, sortConfig]);

      // Compose filters: product group and text search, applied on sortedItems
      useEffect(() => {
        let filtered = [...sortedItems];

        if (selectedGroupId !== "0" && selectedGroupId !== "") {
          filtered = filtered.filter((item) =>
            String(item.productGroupId) === String(selectedGroupId)
          );
        }

        const text = (searchingText || "").replace(/[^\w\s]/gi, "").toLowerCase();
        if (text.length > 0) {
          filtered = filtered.filter((item) =>
            item.fullCodeName.toLowerCase().search(text) !== -1
          );
        }

        setProductList(filtered);
      }, [sortedItems, searchingText, selectedGroupId]);

      const requestSort = (key) => {
        let direction = "ascending";
        if (
          sortConfig &&
          sortConfig.key === key &&
          sortConfig.direction === "ascending"
        ) {
          direction = "descending";
        }
        setSortConfig({ key, direction });
      };

      const onSearchTextChange = (key, propsText) => {
        let x = "";
        if (key === null) {
          if (propsText === undefined || propsText.length === 0) {
            x = "";
          } else {
            x = propsText;
          }
        } else {
          x = key.target.value;
        }
        // update input immediately
        setDisplaySearchText(x);
        // debounce applying filter text
        if (searchDebounceRef.current) {
          clearTimeout(searchDebounceRef.current);
        }
        searchDebounceRef.current = setTimeout(() => {
          setSearchingText(x);
          setSelectedGroupId("0");
        }, 500);
      };

      const onGroupChange = (groupId) => {
        setSelectedGroupId(groupId);
      };

      return {
        items: productList,
        requestSort,
        sortConfig,
        onSearchTextChange: onSearchTextChange,
        searchingText,
        displaySearchText,
        onGroupChange,
        selectedGroupId,
      };
    };

    let updateOuterStates = (orderBy, isAsc) => {
      filtervalue = orderBy;
      orderAsc = isAsc;
    };

    const EnhancedTable = (props) => {
      const { items, requestSort, onSearchTextChange, sortConfig, searchingText, displaySearchText, onGroupChange, selectedGroupId } =
        useSortableData(props.rows, null, this.props.searchText);
      const classes = useStyles();
      const [order, setOrder] = React.useState("");
      const [orderBy, setOrderBy] = React.useState("");
      const inputRef = useRef(null);
      const scrollContainerRef = useRef(null);

      useEffect(() => {
        if (inputRef.current) {
          onSearchTextChange(null, this.props.searchText);
        }
      }, [this.props.searchText]);

      // Restore scroll position after items update
      useEffect(() => {
        if (scrollContainerRef.current && this.scrollPositionToRestore !== undefined) {
          scrollContainerRef.current.scrollTop = this.scrollPositionToRestore;
          // Clear the saved position after restoring
          this.scrollPositionToRestore = undefined;
        }
      }, [items]);

      const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        updateOuterStates(property, isAsc);
      };

      return (
        <div className={classes.root}>
          <Paper style={classes.paper}>
            <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 20,
                }}
              >
                <input
                  id="searchInput"
                  style={{
                    backgroundColor: "#",
                    fontSize: "18.5px",
                    padding: 12,
                    width: "50%",
                    border: "0.5px solid #125688",
                  }}
                  type="search"
                  ref={inputRef}
                  placeholder="Search..."
                  name="search"
                  autoComplete="off"
                  value={displaySearchText}
                  onChange={(e) => onSearchTextChange(e)}
                />
                <select
                  id="orderFilter"
                  style={{
                    fontSize: "18.5px",
                    padding: 12,
                    width: "50%",
                    border: "0.5px solid #125688",
                    backgroundColor: "#fff",
                  }}
                  value={selectedGroupId}
                  onChange={(e) => onGroupChange(e.target.value)}
                >
                  <option value="0">
                    All Products
                  </option>
                  {props.productGroups && props.productGroups.map((group) => (
                    <option value={group.id}>{group.displayText}</option>
                  ))}
                </select>
              </div>
              <br />

          <div id="productTableScrollContainer" ref={scrollContainerRef} style={{ maxHeight: 700, overflow: "scroll" }}>
              <Table
                stickyHeader
                style={classes.table}
                aria-labelledby="tableTitle"
                size={"medium"}
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={items.length}
                />
                <TableBody>
                  {stableSort(
                    // unitRate/lineTotal live in the separate pricePreview lookup, not on the row - attach them here so the existing sort can read row[orderBy].
                    items.map((row) => {
                      const pricing = (this.props.pricePreview || {})[row.productId];
                      return {
                        ...row,
                        unitRate: pricing ? pricing.unitPrice : -1,
                        lineTotal: pricing ? pricing.lineTotal : -1,
                      };
                    }),
                    getComparator(order, orderBy)
                  ).map(
                    (row, index) => {
                      return (
                        <TableRow hover key={row.productId}>
                          <TableCell style={classes.tableCell}>
                            {row.frequency}
                          </TableCell>
                          {/*<TableCell*/}
                          {/*  component="th"*/}
                          {/*  id={row.productId}*/}
                          {/*  scope="row"*/}
                          {/*  style={classes.productTableCell}*/}
                          {/*>*/}
                          {/*  {row.productCode}*/}
                          {/*</TableCell>*/}
                          <Tooltip title={
                            <span>
                              Product code: {row.productCode} 
                              <br />
                              Product Group: {row.productGroupName}
                            </span>
                          }>
                            <TableCell style={classes.productTableCell}>
                              {row.productName}
                            </TableCell>
                          </Tooltip>

                          <TableCell style={classes.tableCell}>
                            <TextField
                              id="outlined-full-width"
                              placeholder="Units.."
                              margin="dense"
                              variant="outlined"
                              size="small"
                              autoComplete="off"
                              type="number"
                              disabled={!row.canBeSoldSeparately}
                              defaultValue={row.units}
                              onBlur={(e) =>
                                this.handleUnitChange(
                                  e.target.value,
                                  row.productId,
                                  row.packs
                                )
                              }
                              InputLabelProps={{
                                shrink: true,
                              }}
                              InputProps={{ inputProps: { min: 0 } }}
                            />
                          </TableCell>

                          <TableCell style={classes.tableCell}>
                            <TextField
                              id="outlined-full-width"
                              placeholder="Packs.."
                              margin="dense"
                              variant="outlined"
                              size="small"
                              autoComplete="off"
                              type="number"
                              defaultValue={row.packs}
                              onBlur={(e) =>
                                this.handlePackChange(
                                  e.target.value,
                                  row.productId,
                                  row.units
                                )
                              }
                              InputLabelProps={{
                                shrink: true,
                              }}
                              InputProps={{ inputProps: { min: 0 } }}
                            />
                          </TableCell>

                          <TableCell style={classes.tableCell}>
                            {formatNumberWithDecimals(row.totalWeight)}
                          </TableCell>
                          <TableCell style={classes.tableCell}>
                            {row.packSize}
                          </TableCell>
                          <TableCell style={classes.tableCell}>
                            {row.weight.toFixed(4)}
                          </TableCell>
                          <TableCell style={classes.tableCell}>
                            {formatNumber(row.quantity)}
                          </TableCell>
                          <TableCell style={classes.tableCell}>
                            {this.state.pendingPriceProductIds.has(row.productId) ? (
                              <CircularProgress size={16} />
                            ) : (this.props.pricePreview || {})[row.productId] ? (
                              formatCurrency(this.props.pricePreview[row.productId].unitPrice)
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell style={classes.tableCell}>
                            {this.state.pendingPriceProductIds.has(row.productId) ? (
                              <CircularProgress size={16} />
                            ) : (this.props.pricePreview || {})[row.productId] ? (
                              formatCurrency(this.props.pricePreview[row.productId].lineTotal)
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </div>
      );
    };

    if (isEmpty(this.props.productList)) {
      return (
        <div style={{ textAlign: "center" }}>
          <h3>No products found for this quote.</h3>
        </div>
      );
    } else {
      return (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <TableContainer>
              <div>
                <EnhancedTable rows={this.props.productList} productGroups={this.props.productGroups} />
              </div>
            </TableContainer>
          </GridItem>
        </GridContainer>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    productList: state.orderReducer.productList,
    searchText: state.orderReducer.searchText,
    productGroups: state.orderReducer.productGroups,
    pricePreview: state.orderReducer.productPricePreview,
    user: state.userReducer.user,
    selectedDeliverySiteId: state.orderReducer.selectedDeliverySiteId,
    selectedBranchId: state.orderReducer.selectedBranchId,
    selectedQuoteId: state.orderReducer.selectedQuoteId,
    totalWeight: state.orderReducer.totalWeight,
  };
};

export default connect(mapStateToProps, {
  updateWeight,
  updateProductList,
  updateSearchText,
  getProductPricePreview,
})(withStyles(useStyles)(OrderProductsTable));
